import { LoanType } from '../../../../common/constants/LoanType';

/**
 * A portfolio loan: more than one property, and not a Master Note. The same rule EditStdLoanModal uses to show the
 * portfolio overage repayments grid. Pass the store's setup.loanTypeId and loanStepContext.propertyCount.
 */
export const isPortfolioLoan = (loanTypeId: LoanType | undefined, propertyCount: number) =>
    propertyCount > 1 && loanTypeId !== LoanType.MasterNote;
